import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { ThemeProvider } from "@mui/material/styles";
import { useAuth } from "../../context/AuthContext";
import { useForm } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import { sendPasswordResetEmail, auth } from "../../firebase";

export default function Forgot() {
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [processing, setProcessing] = useState(false);
  const { resetPassword, currentUser } = useAuth();
  const [DBerror, setDBerror] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const submit = async (data) => {
    try {
      setMessage("");
      setError("");

      await sendPasswordResetEmail(auth, data.email).then((res) => {
        setMessage("Email is sent. Check your inbox for further instructions.");
      });
    } catch (error) {
      switch (error.code) {
        case "auth/user-not-found":
          setDBerror("The email is not found in our database. Please sign up.");
          break;
        default:
          setDBerror("An undefined error happened. Please try again.");
      }
      console.log(error);
      setMessage(
        (prev) =>
          "There is something wrong with the email. Please try again later."
      );
    }
  };

  return (
    <ThemeProvider>
      <Container component="main" maxWidth="xs" sx={{ paddingBottom: "100px" }}>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "#6573c3" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <Box sx={{ paddingTop: "10px" }}>
            We will send an email to reset the password.
          </Box>
          <Box
            style={{
              position: "relative",
              top: "+3px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {errors.email && (
              <Alert severity="warning">{errors.email?.message}</Alert>
            )}
            {!errors.email && DBerror && (
              <Alert severity="warning">{DBerror}</Alert>
            )}
          </Box>
          <Box sx={{ mt: 1 }}>
            <form
              onSubmit={handleSubmit((data) => {
                submit(data);
              })}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                label="Email Address"
                autoComplete="email"
                autoFocus
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please put valid email address.",
                  },
                })}
              />

              <Box sx={{ my: 3 }}>
                <button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className="custom_btn"
                  disabled={processing}
                >
                  <>
                    {processing ? (
                      <>
                        <CircularProgress size={12} />
                      </>
                    ) : (
                      <>Send Email</>
                    )}
                  </>
                </button>
              </Box>
            </form>
            <Grid container>
              <Grid item>
                <Link href="/login" variant="body2">
                  Go to Login
                </Link>
              </Grid>
              <Grid item>&nbsp;&nbsp;&nbsp;</Grid>
              <Grid item>
                <Link href="/signup">Don't have an account? Sign Up</Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
